const baseStats = {
	1:{
		Price: 100,
		HP: 10,
		BAB: 2,
		DamageDie: "1d4",
		DamageMod: 1,
		EAC: 11,
		KAC: 14,
		GoodSave: 4,
		PoorSave: 1,
		AbilityModGood: 2,
		AbilityModPoor: 1,
		Skill: 5,
	},
	2:{
		Price: 500,
		HP: 20,
		BAB: 3,
		DamageDie: "1d4",
		DamageMod: 2,
		EAC: 12,
		KAC: 15,
		GoodSave: 5,
		PoorSave: 1,
		AbilityModGood: 2,
		AbilityModPoor: 1,
		Skill: 6,
	},
	3:{
		Price: 1200,
		HP: 30,
		BAB: 4,
		DamageDie: "1d4",
		DamageMod: 3,
		EAC: 13,
		KAC: 16,
		GoodSave: 5,
		PoorSave: 2,
		AbilityModGood: 2,
		AbilityModPoor: 1,
		Skill: 7,
	},
	4:{
		Price: 1800,
		HP: 40,
		BAB: 5,
		DamageDie: "1d4",
		DamageMod: 4,
		EAC: 15,
		KAC: 18,
		GoodSave: 5,
		PoorSave: 2,
		AbilityModGood: 2,
		AbilityModPoor: 1,
		Skill: 8,
	},
	5:{
		Price: 2700,
		HP: 55,
		BAB: 6,
		DamageDie: "1d4",
		DamageMod: 5,
		EAC: 16,
		KAC: 19,
		GoodSave: 7,
		PoorSave: 3,
		AbilityModGood: 2,
		AbilityModPoor: 1,
		Skill: 9,
	},
	6:{
		Price: 4900,
		HP: 65,
		BAB: 7,
		DamageDie: "1d6",
		DamageMod: 6,
		EAC: 17,
		KAC: 20,
		GoodSave: 7,
		PoorSave: 3,
		AbilityModGood: 2,
		AbilityModPoor: 1,
		Skill: 10,
	},
	7:{
		Price: 5400,
		HP: 80,
		BAB: 9,
		DamageDie: "1d8",
		DamageMod: 7,
		EAC: 19,
		KAC: 22,
		GoodSave: 8,
		PoorSave: 4,
		AbilityModGood: 3,
		AbilityModPoor: 2,
		Skill: 12,
	},
	8:{
		Price: 8400,
		HP: 90,
		BAB: 10,
		DamageDie: "1d12",
		DamageMod: 8,
		EAC: 20,
		KAC: 23,
		GoodSave: 8,
		PoorSave: 4,
		AbilityModGood: 3,
		AbilityModPoor: 2,
		Skill: 13,
	},
	9:{
		Price: 12000,
		HP: 105,
		BAB: 11,
		DamageDie: "3d4",
		DamageMod: 9,
		EAC: 21,
		KAC: 24,
		GoodSave: 8,
		PoorSave: 4,
		AbilityModGood: 3,
		AbilityModPoor: 2,
		Skill: 14,
	},
	10:{
		Price: 17000,
		HP: 120,
		BAB: 13,
		DamageDie: "2d8",
		DamageMod: 10,
		EAC: 23,
		KAC: 26,
		GoodSave: 10,
		PoorSave: 5,
		AbilityModGood: 3,
		AbilityModPoor: 2,
		Skill: 15,
	},
	11:{
		Price: 23000,
		HP: 135,
		BAB: 14,
		DamageDie: "2d10",
		DamageMod: 11,
		EAC: 23,
		KAC: 26,
		GoodSave: 10,
		PoorSave: 6,
		AbilityModGood: 3,
		AbilityModPoor: 2,
		Skill: 16,
	},
	12:{
		Price: 31000,
		HP: 145,
		BAB: 14,
		DamageDie: "2d12",
		DamageMod: 12,
		EAC: 24,
		KAC: 27,
		GoodSave: 10,
		PoorSave: 6,
		AbilityModGood: 3,
		AbilityModPoor: 2,
		Skill: 17,
	},
	13:{
		Price: 46000,
		HP: 160,
		BAB: 16,
		DamageDie: "6d4",
		DamageMod: 13,
		EAC: 26,
		KAC: 29,
		GoodSave: 11,
		PoorSave: 6,
		AbilityModGood: 4,
		AbilityModPoor: 3,
		Skill: 19,
	},
	14:{
		Price: 63000,
		HP: 175,
		BAB: 17,
		DamageDie: "6d6",
		DamageMod: 14,
		EAC: 27,
		KAC: 30,
		GoodSave: 11,
		PoorSave: 6,
		AbilityModGood: 4,
		AbilityModPoor: 3,
		Skill: 20,
	},
	15:{
		Price: 94000,
		HP: 190,
		BAB: 18,
		DamageDie: "5d8",
		DamageMod: 15,
		EAC: 28,
		KAC: 31,
		GoodSave: 12,
		PoorSave: 8,
		AbilityModGood: 4,
		AbilityModPoor: 3,
		Skill: 21,
	},
	16:{
		Price: 144000,
		HP: 205,
		BAB: 19,
		DamageDie: "6d8",
		DamageMod: 16,
		EAC: 30,
		KAC: 33,
		GoodSave: 12,
		PoorSave: 8,
		AbilityModGood: 4,
		AbilityModPoor: 3,
		Skill: 22,
	},
	17:{
		Price: 216000,
		HP: 225,
		BAB: 20,
		DamageDie: "8d6",
		DamageMod: 17,
		EAC: 31,
		KAC: 34,
		GoodSave: 12,
		PoorSave: 8,
		AbilityModGood: 4,
		AbilityModPoor: 3,
		Skill: 23,
	},
	18:{
		Price: 325000,
		HP: 250,
		BAB: 21,
		DamageDie: "8d8",
		DamageMod: 18,
		EAC: 32,
		KAC: 35,
		GoodSave: 13,
		PoorSave: 8,
		AbilityModGood: 4,
		AbilityModPoor: 3,
		Skill: 24,
	},
	19:{
		Price: 480000,
		HP: 275,
		BAB: 23,
		DamageDie: "9d8",
		DamageMod: 19,
		EAC: 34,
		KAC: 37,
		GoodSave: 13,
		PoorSave: 9,
		AbilityModGood: 5,
		AbilityModPoor: 4,
		Skill: 26,
	},
	20:{
		Price: 720000,
		HP: 300,
		BAB: 23,
		DamageDie: "13d6",
		DamageMod: 20,
		EAC: 35,
		KAC: 38,
		GoodSave: 14,
		PoorSave: 9,
		AbilityModGood: 5,
		AbilityModPoor: 4,
		Skill: 27,
	},
};

const state = {
	stats: baseStats,
}

const getters = {
	companion: (state, getters, rootState, rootGetters) => {
		//TODO: change this to compiled companion stats for current level
		var companion = rootState.Character.Levels[rootGetters.currentLevel].Companion
		return Object.is( companion, undefined) ? null : companion
	},
	hasCompanionAtLevel: (state, getters, rootState) => (concernedLevel) => {
		var levels = rootState.Character.Levels
		for (const level in levels) {
			if(level <= concernedLevel && levels[level].Companion != undefined){
				return true
			}
		}
		return false
	},
	hasCompanion: (state, getters, rootState, rootGetters) => {
		return getters.hasCompanionAtLevel( rootGetters.currentLevel )
	},
	valueOrNull: (state, getters, rootState) => (key, level) => {
		return rootState.Character.Levels[level].Companion[key] || null
	},
	name: (state, getters) => (level) => {
		return getters.valueOrNull('Name',level)
	},
	cLevel: (state, getters) => (level) => {
		return getters.valueOrNull('Level',level)
	},
	size: (state, getters) => (level) => {
		return getters.valueOrNull('Size',level)
	},
	type: (state, getters) => (level) => {
		return getters.valueOrNull('Type',level)
	},
	senses: (state, getters) => (level) => {
		return getters.valueOrNull('Senses',level)
	},
	save: (state, getters) => (level) => {
		return getters.valueOrNull('GoodSave',level)
	},
	defenses: (state, getters) => (level) => {
		return getters.valueOrNull('Defenses',level)
	},
	resistances: (state, getters) => (level) => {
		return getters.valueOrNull('Resistances',level)
	},
	weaknesses: (state, getters) => (level) => {
		return getters.valueOrNull('Weaknesses',level)
	},
	speed: (state, getters) => (level) => {
		return getters.valueOrNull('Speed',level)
	},
	attacks: (state, getters) => (level) => {
		return getters.valueOrNull('Attacks',level)
	},
	abilityMods: (state, getters) => (level) => {
		return getters.valueOrNull('AbilityMods',level)
	},
	abilityBest: (state, getters) => (level) => {
		return getters.valueOrNull('AbilityBest',level)
	},
	abilityBetter: (state, getters) => (level) => {
		return getters.valueOrNull('AbilityBetter',level)
	},
	specialAbilities: (state, getters) => (level) => {
		return getters.valueOrNull('Specials',level)
	},
	stats: (state, getters) => {
		if( getters.companion != null ){
			return state.stats[getters.companion.Level]
		} else {
			return null
		}
	},
}

import _merge from 'lodash.merge'

function ucfirst( input ) {
	return input.charAt(0).toUpperCase() + input.slice(1);
}

function generateActions(properties) {
	var actions = {}
	for(const property in properties) {
		actions[`update${ucfirst(property)}`] = ({ dispatch }, payload) => {
			console.log(`dispatch: update${ucfirst(property)}`)//eslint-disable-line
			dispatch('setCompanionProp', _merge( payload, { 
				property: properties[property],
			}))
		}
	}
	return actions
}

const actions = {
	setCompanionProp: ( {commit}, payload ) => {
		commit('setCharacterProp',[
			{
				key: `Levels[${payload.level}].Companion.${payload.property}`,
				val: payload.value
			}
		],{
			root: true,
		})
	},
	...generateActions({
		name: 'Name',
	})
}

const mutations = {

}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}